<script>
    import { getContext } from 'svelte';
    import Button from 'components/Button';

    export let onClose = () => {};

    const { close } = getContext('simple-modal');

    function handleClose() {
        onClose();
        close();
    }
</script>

<div class="modal">
    <div class="modal-content">
        <h2 class="modal-content__title">Mandatory Life Insurance</h2>
        <div class="modal__desc">
            <p>
                As a condition for loan approval and continuance, Standard Credit may require some applicants to obtain and
                maintain life insurance coverage equal to the outstanding balance of the loan.
            </p>

            <p>
                You have the right to substitute this coverage with an assignable life insurance policy of your choice,
                provided it offers terms and benefits that are equivalent to or better than those required by Standard
                Credit. A copy of the proposed policy must be submitted for review to confirm both its eligibility and
                in-force status. Once confirmed as eligible, your insurer will be required to record an assignment of
                the policy to Standard Credit for the duration of the loan.
            </p>

            <p>
                Applicants who choose to use their own life insurance policy must also provide proof of its in-force
                status.
            </p>
            <p>
                <strong> Waiver of Requirement </strong> <br />
                Standard Credit reserves the sole right to waive the requirement for life insurance coverage.
            </p>
            <p>
                <a href="/pdfs/life_insurance.pdf" target="_blank">Click here</a> for a Summary of Pan-American Life Terms
                and Conditions
            </p>
        </div>
    </div>
    <div class="actions">
        <Button primary small onClick={handleClose}>OK</Button>
    </div>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .modal-content {
        margin-bottom: em(30);
        padding: em(30) em(30) 0 em(30);

        &__title {
            margin-bottom: em(25);
            font-size: em(20);
            font-weight: $fw-bold;
            color: $color-primary;
            line-height: 1.25;
        }

        :global(p) {
            margin-bottom: em(25);
        }
    }

    .contacts {
        display: block;
        justify-content: flex-start;
        grid-template-columns: 1fr 1fr;
        flex-flow: row wrap;
        align-items: center;
        margin-top: em(30);

        @include for-tablet-landscape-up {
            display: grid;
        }

        &__contact {
            width: 100%;
            margin: em(20) 0;
            font-size: em(16);
            display: flex;
            flex-flow: column nowrap;
            align-items: start;
            justify-content: start;
            row-gap: 5px;
        }

        &__name {
            margin-bottom: em(10);
            color: $color-black;
        }

        &__number {
            display: flex;
            justify-content: start;
            align-items: center;
            column-gap: 5px;
            flex-wrap: nowrap;
            margin-bottom: em(5);
            font-weight: $fw-bold;
            color: $color-primary;
        }
    }

    .actions {
        padding: em(10) em(25);
        border-radius: 0 0 em(25) em(25);
        background: $color-gray-light;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;
    }
</style>
